import { DEFAULT_TABLE_CONFIG } from './constants';
import * as actionTypes from './actionTypes';
// import type { Report } from './types';
// import type { ReportsTableObject } from 'modules/reportsTable/types';

export function loadReport(id /*: number */) {
  return {
    type: actionTypes.LOAD_REPORT_BY_ID,
    id,
  };
}

export function fetchReportDataRequest(reportId /*: number */) {
  return {
    type: actionTypes.FETCH_REPORT_DATA_REQUEST,
    reportId,
  };
}

export function fetchReportDataResponse(id /*: number */, reportData, reportSummaryData) {
  return {
    type: actionTypes.FETCH_REPORT_DATA_RESPONSE,
    id,
    reportData,
    reportSummaryData,
  };
}

export function fetchReportDataError(id /*: number */, error) {
  return {
    type: actionTypes.FETCH_REPORT_DATA_ERROR,
    id,
    error,
  };
}

export function fetchReportRequest(id /*: number */) {
  return {
    type: actionTypes.FETCH_REPORT_BY_ID_REQUEST,
    id,
  };
}

export function fetchReportResponse(reportResponse /*: anyp[] */) {
  return {
    type: actionTypes.FETCH_REPORT_BY_ID_RESPONSE,
    report: reportResponse,
  };
}

export function fetchReportError(error) {
  return {
    type: actionTypes.FETCH_REPORT_BY_ID_ERROR,
    error,
  };
}

export function resetReport() {
  return {
    type: actionTypes.RESET_REPORT,
  };
}

export function saveReport(report /*: Report */) {
  return {
    type: actionTypes.SAVE_REPORT_REQUEST,
    report,
  };
}

export function saveReportResponse(report /*: Report */) {
  return {
    type: actionTypes.SAVE_REPORT_RESPONSE,
    report,
  };
}

export function saveReportError(error, report /*: Report */) {
  return {
    type: actionTypes.SAVE_REPORT_ERROR,
    report,
    error,
  };
}

export function updateReportFilters(filters) {
  return {
    type: actionTypes.UPDATE_REPORT_FILTERS,
    filters,
  };
}

export function fetchReportingTypeTable(
  reportingType /*: string */,
  reportingTypeTable /*: ReportsTableObject */,
) {
  // every time this request happens, it will be fetching the initialState of
  // tableConfig and then reseting the tableConfig in the store
  // this current implementation could be prone to breakage so we should
  // refactor this when we get a chance
  return {
    type: actionTypes.FETCH_REPORT_MODAL_TABLE_DATA_REQUEST,
    reportsTableRequest: {
      filter: DEFAULT_TABLE_CONFIG,
      selectedTypeIds: reportingTypeTable.selectedTypeIds[reportingType],
      reportingType,
    },
  };
}

export function fetchReportingTypeTableResponse(
  reportsTableResponse /*: {
    response: { data: Array<Object> },
    selectedTypeIds Array<string>,
    selectedTypeIdsInModal Array<string>,
    campaignIdResponse?: { data: Array<Object> },
  } */,
  isUpdatingTableFilter /*: boolean */ = false,
) {
  const responseObj = reportsTableResponse.response.data;
  let { total } = responseObj;
  const actionType = isUpdatingTableFilter
    ? actionTypes.FETCH_UPDATE_REPORT_MODAL_TABLE_DATA_RESPONSE
    : actionTypes.FETCH_REPORT_MODAL_TABLE_DATA_RESPONSE;
  if (responseObj.workflows) {
    return {
      type: actionType,
      ...responseObj,
      results: responseObj.workflows,
      selectedTypeIds: reportsTableResponse.selectedTypeIds,
      selectedTypeIdsInModal: reportsTableResponse.selectedTypeIdsInModal,
      componentType: 'Workflow',
    };
  }
  const idSet = new Set();
  const campaignIDResponseObj = reportsTableResponse?.campaignIdResponse?.data?.results;

  if (campaignIDResponseObj) {
    responseObj.results.forEach((val) => {
      idSet.add(val.id);
    });
    campaignIDResponseObj.forEach((recur) => {
      if (!idSet.has(recur.id)) {
        responseObj.results.push(recur);
        total += 1;
      }
    });
  }
  return {
    type: actionType,
    ...responseObj,
    total,
    results: responseObj.results,
    selectedTypeIds: reportsTableResponse.selectedTypeIds,
    selectedTypeIdsInModal: reportsTableResponse.selectedTypeIdsInModal,
    componentType: 'Campaign',
  };
}

export function fetchReportingTypeTableError(error) {
  return {
    type: actionTypes.FETCH_REPORT_MODAL_TABLE_DATA_ERROR,
    error,
  };
}

export function updateReportingTypeModalIds(checked /*: boolean */, id /*: number */) {
  return {
    type: checked
      ? actionTypes.ADD_REPORTING_TYPE_MODAL_ID
      : actionTypes.REMOVE_REPORTING_TYPE_MODAL_ID,
    id,
  };
}

// this gets called whenever the table in the report modal gets filtered/paged/sorted
export function updateReportingTypeTableFilters(config) {
  return {
    type: actionTypes.UPDATE_REPORT_MODAL_TABLE_DATA,
    config,
  };
}

export function clearReportingTypeModalIds() {
  return {
    type: actionTypes.CLEAR_REPORTING_TYPE_MODAL_IDS,
  };
}

export function initializeSelectedTypeIds(
  componentType /*: string */,
  componentIds /*: number[] */,
) {
  return {
    type: actionTypes.INITIALIZE_SELECTED_TYPE_IDS,
    report: {
      componentType,
      componentIds,
    },
  };
}

export function saveReportingTypeModalIds(
  ids /*: Array<number> */,
  reportId /*: number */,
  componentType /*: string */,
) {
  return {
    type: actionTypes.UPDATE_REPORTING_TYPE_IDS,
    ids,
    reportId,
    componentType,
  };
}

export function updateChartType(
  reportId /*: number */,
  dataView /*: number */,
  chartType /*: string */,
) {
  return {
    type: actionTypes.SELECT_HIGHCHARTS_TYPE,
    reportId,
    dataView,
    chartType,
  };
}

export function updateMetricsList(reportId /*: number */, metricsList /*: Array<String> */) {
  // post metricsList to backend here
  return {
    type: actionTypes.UPDATE_METRICS_LIST,
    reportId,
    metricsList,
  };
}

export function metricsListUpdated(reportId /*: number */, metricsList /*: Array<any> */) {
  // post metricsList to backend here
  return {
    type: actionTypes.METRICS_LIST_UPDATED,
    reportId,
    metricsList,
  };
}

export function updateReportParams(reportId /*: number */, updatedParams) {
  return {
    type: actionTypes.REPORT_PARAMS_UPDATED,
    reportId,
    ...updatedParams,
  };
}

export function updateMetricsListError(error) {
  return {
    type: actionTypes.UPDATE_METRICS_LIST_ERROR,
    error,
  };
}

export function resetReportDataViews() {
  return {
    type: actionTypes.RESET_REPORT_DATA_VIEWS,
  };
}

export function updateReportDetailsTableConfig(tableConfig) {
  return {
    type: actionTypes.UPDATE_TABLE_CONFIG,
    tableConfig,
  };
}

export function updateActiveDataViewItem(activeView /*: number */) {
  return {
    type: actionTypes.UPDATE_ACTIVE_DATA_VIEW_ITEM,
    activeView,
  };
}

export function exportReportDataAsCsvRequest(reportId /*: number */, callback /*: () => void */) {
  return {
    type: actionTypes.EXPORT_REPORT_DATA_AS_CSV_REQUEST,
    reportId,
    callback,
  };
}

export function exportReportDataAsCsvResponse(csvData /*: string */) {
  return {
    type: actionTypes.EXPORT_REPORT_DATA_AS_CSV_RESPONSE,
    csvData,
  };
}

export function exportReportDataAsCsvError(error) {
  return {
    type: actionTypes.EXPORT_REPORT_DATA_AS_CSV_ERROR,
    error,
  };
}

export function saveAndExportReportDataAsCsvRequest(
  report /*: number */,
  callback /*: (string) => void */,
) {
  return {
    type: actionTypes.SAVE_AND_EXPORT_REPORT_DATA_AS_CSV_REQUEST,
    report,
    callback,
  };
}
